/**
 * config imports
 */

import { ApolloClient, InMemoryCache } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { setContext } from "@apollo/client/link/context";

import { getToken } from "./auth";

const baseURL = process.env.REACT_APP_API_GRAPHQL_URL;

const uploadLink = createUploadLink({
    uri: baseURL,
});

const authLink = setContext(async (_, { headers }) => {
    const token = getToken();

    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : "",
        },
    };
});

const client = new ApolloClient({
    link: authLink.concat(uploadLink),
    cache: new InMemoryCache(),
});

export default client;
